module.exports = __webpack_public_path__ + "static/media/nophoto.b63f2733.png";